export type EventRouteVote = {
    difficulty: number
    route: number
}
export const EVENT_ROUTE_VOTE = "climbpressRouteVote";
export type EventRouteUnvote = {
    route: number
}
export const EVENT_ROUTE_UNVOTE = "climbpressRouteUnvote";
export type EventRouteExpandToggle = {
    route: number
}
export const EVENT_ROUTE_EXPAND_TOGGLE = "climbpressRouteExpandToggle";